import { Dispatch } from 'redux';

import { deleteMobileAuthToken } from '../../apis/auth';
import { logoutAction } from '../../state/actions/auth';
import { dismissPrivileges } from '../../state/actions/privileges';
import { dismissTenantConfig } from '../../state/actions/tenant';

export const logoutUser = async (dispatch: Dispatch) => {
  await deleteMobileAuthToken();
  dispatch(dismissPrivileges());
  dispatch(dismissTenantConfig());
  dispatch(logoutAction());
};
